import script from "./TunnelProduit.vue?vue&type=script&setup=true&lang=js"
export * from "./TunnelProduit.vue?vue&type=script&setup=true&lang=js"

import "./TunnelProduit.vue?vue&type=style&index=0&id=41912bbf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41912bbf"]])

export default __exports__